import { useContext, useEffect, useState } from 'react';
import { createRoot } from 'react-dom/client';
import atlas from 'azure-maps-control';
import { AzureMapsContext } from 'react-azure-maps';

function InteractivePopup({ children, isVisible = true, options, events }) {
  const { mapRef } = useContext(AzureMapsContext);
  // Create a container for the popup content
  const containerRef = document.createElement('div');
  // Create a React root for rendering the popup's children
  const root = createRoot(containerRef);

  const [popupRef] = useState(() =>
    new atlas.Popup({
      ...options,
      content: containerRef,
      shadow: false
    })
  );

  // Attach events to the popup when mounted
  useEffect(() => {
    if (mapRef) {
      if (events) {
        events.forEach(({ eventName, callback }) => {
          mapRef.events.add(eventName, popupRef, callback);
        });
      }
      // Cleanup when unmounted
      return () => {
        mapRef.popups.remove(popupRef);
      };
    }
  }, [mapRef, popupRef, events]);

  // Re-render the popup content if children or options change
  useEffect(() => {
    root.render(children);
    popupRef.setOptions({
      ...options,
      content: containerRef,
    });

    if (mapRef && isVisible && !popupRef.isOpen()) {
      popupRef.open(mapRef);
    }
  }, [children, options, mapRef, popupRef, isVisible, root, containerRef]);

  // Toggle the popup visibility
  useEffect(() => {
    if (mapRef) {
      if (isVisible && !popupRef.isOpen()) {
        popupRef.open(mapRef);
      } else if (mapRef.popups.getPopups().length && !isVisible && popupRef.isOpen()) {
        popupRef.close();
      }
    }
  }, [isVisible, mapRef, popupRef]);

  return null;
}

export default InteractivePopup;
